<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="createCategory">
      <b-form
          class="mt-2"
          @submit.prevent="handleSubmit"
          @keydown.enter="handleSubmit"
      >
        <b-row>

          <b-col cols="12">
            <h4 class="mb-2">Detalles categoría</h4>
          </b-col>
          <b-col :cols="12">
            <b-form-group :label="'Activo'" label-for="category-active" >
              <b-form-checkbox
                  v-model="active"
                  switch
                  :value="1"
                  :unchecked-value="0"
              />
            </b-form-group>
          </b-col>
          <b-col :cols="12">
            <validation-provider
                #default="{ errors }"
                name="Nombre"
                rules="required"
            >
              <b-form-group label="Nombre" label-for="category-name">
                <b-form-input
                    v-model="name"
                    name="name"
                    placeholder="Nombre"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <b-form-group
                :label="'Descripción'"
                label-for="category-description"
            >
              <quill-editor
                  v-model="description"
                  :options="editorOption"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12 text-right">
            <b-button type="submit" variant="primary" class="mt-2 mr-1">
              Enviar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import Ripple from "vue-ripple-directive";
import ImageDropzone from "@/components/elements/ImageDropzone/ImageDropzone.vue";
import { quillEditor } from 'vue-quill-editor'
import quillMixin from '@/mixins/quillMixin'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  mixins: [quillMixin],
  data() {
    return {
      name: "",
      description: "",
      active: 0,
      required,
      email,
    };
  },
  computed: {
    ...mapGetters({
      currentClient: 'clients/getCurrentClient'
    }),
  },
  methods: {
    ...mapActions({
      create: "documents/createCategory",
    }),
    handleSubmit() {
      this.$refs.createCategory.validate().then((success) => {
        if (success) {
          const formData = this.createFormData();
          if (formData) {
            this.create({ category: formData });
          }
        }
      });
    },
    createFormData() {
      const data = new FormData();

      data.append("name", this.name);
      data.append("description", this.description);
      data.append("client_id", this.currentClient.id);
      data.append("active", this.active);

      return data;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
